import { render } from "./SearchRes.vue?vue&type=template&id=d343b494&scoped=true"
import script from "./SearchRes.vue?vue&type=script&lang=js"
export * from "./SearchRes.vue?vue&type=script&lang=js"

import "./SearchRes.vue?vue&type=style&index=0&id=d343b494&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d343b494"]])

export default __exports__